import createRoute         from '@widesk-ui/tools/createRoute';
import RelatedContentModel from '@models/shop/RelatedContentModel';

export default createRoute.splitView('/related_contents', 'shop', 'RelatedContentSplitView', RelatedContentModel.localize('plural'));
